import { type FormikConfig, useFormik } from "formik";
import { type FormikValues } from "formik/dist/types";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useForm<Values extends FormikValues = FormikValues>(
  formikConfig: FormikConfig<Values>
) {
  return useFormik({
    validateOnBlur: false,
    validateOnChange: false,
    ...formikConfig,
  });
}

export default useForm;
